import React, { FC } from 'react';

import {
  useAppSettings,
  useCanEditMember,
  useMember,
} from '../../../../contexts/widgets';
import Title from './Title';
import EmptyState from './EmptyState';
import PostList from './PostList';
import { shouldForceEmptyState } from './hooks';

export const BlogPosts: FC = () => {
  const { blogPosts } = useMember();
  const { canEditMember } = useCanEditMember();
  const appSettings = useAppSettings();
  const shouldShowEmptyState = canEditMember && !blogPosts.length;

  return (
    <>
      <Title />
      {shouldShowEmptyState || shouldForceEmptyState(appSettings) ? (
        <EmptyState />
      ) : (
        <PostList />
      )}
    </>
  );
};
